import { graphql } from '__generated__';

export const GetStudyCustomerForPendoQuery = graphql(`
    query GetStudyCustomerForPendo($pk: String!) {
        getStudy(pk: $pk) {
            customerId
            customerName
        }
    }
`);
